import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';
import { sendMixPanelFilterEvent } from './index';

export const reportWorkSampleFilterEvent = (type, { text }) => {
    tracker.sendBQEvent(
        getBQClickFields({
            type: type.BigQuery,
            text,
            elementName: 'work_sample',
            componentName: 'reviews_header',
        })
    );

    sendMixPanelFilterEvent({ filterType: type.Mixpanel });
};

export const TYPES = {
    workSample: {
        onClick: {
            BigQuery: 'clicked_on_work_sample_toggle_on',
            Mixpanel: 'WorkSample on',
        },
        offClick: {
            BigQuery: 'clicked_on_work_sample_toggle_off',
            Mixpanel: 'WorkSample off',
        },
    },
};
